import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const RestaurantNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-card border border-border rounded-2xl p-8 text-center">
        <h1 className="text-2xl font-bold text-foreground mb-2">Restaurant not found</h1>
        <p className="text-muted-foreground mb-6">
          This restaurant subdomain is not active or does not exist.
        </p>
        <Button onClick={() => navigate('/')}>Go to home</Button>
      </div>
    </div>
  );
};

export default RestaurantNotFound;
